import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { rrulestr } from 'rrule';

dayjs.extend(utc);

/** Next occurrence of `recurrence` (anchored at `dtstart`) strictly after `after`. */
export const getNextRecurrenceStartTime = (
  recurrence: string,
  dtstart: string,
  after: string,
): string | null => {
  const rule = rrulestr(recurrence, { dtstart: new Date(dtstart) });
  const nextDate = rule.after(new Date(after), false);

  return nextDate ? nextDate.toISOString() : null;
};

/**
 * Reconstruct the edited occurrence's original instant: the edited day (from the
 * possibly-retimed form value) at the series' original time of day. Anchoring the
 * continuation lookup on this — rather than the new form time — stops an
 * earlier-in-the-day edit from pulling the next occurrence back onto the edited
 * day. The stored RRULE carries no TZID, so occurrences sit at dtstart's UTC time.
 */
export const getEditedOccurrenceStartTime = (
  initialEventStartTime: string,
  editedStartTime: string,
): string => {
  const initial = dayjs.utc(initialEventStartTime);
  return dayjs
    .utc(editedStartTime)
    .hour(initial.hour())
    .minute(initial.minute())
    .second(initial.second())
    .millisecond(initial.millisecond())
    .toISOString();
};
